export const selectTaxCategoriesList = (store) =>
  store.taxCategoriesState.sort((a, b) => a < b );



// WEBPACK FOOTER //
// ./src/store/selectors/taxCategories.js